export const i18nLangs = ['en', 'fr', 'it'];
